import Vue from 'vue';
import Vuetify from 'vuetify'
//import Vuetify from 'vuetify/lib';
// import 'vuetify/dist/vuetify.min.css'
import 'vuetify/dist/vuetify.min.css'
import pt from 'vuetify/es5/locale/pt'
// import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css' 
Vue.use(Vuetify);

// Vue.component('my-component', {
//   methods: {
//     changeLocale () {
//       this.$vuetify.lang.current = 'sv'
//     },
//   },
// })

export default new Vuetify({
    icons: {
      iconfont: 'mdi',  // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
    },
    theme: {
      themes: {
        light: {
            //eapp
            primary: '#627AAD',
            second: '#BEC3CC'
            
            //union
            // primary: '#1AB394',
            // second: '#D1F0EA'
        
        //   secondary: '#b0bec5',
        //   accent: '#8c9eff',
        //   error: '#b71c1c',
        //   inspinia: '#1ab394'
            
        },
      },
    },
    // lang: {
    //   locales: { pt },
    //   current: 'pt'
    // },
  });

  //eApp
  //627AAD
  //BEC3CC

  //uni on
  //1AB394
  //D1F0EA